import * as yup from 'yup';
import { array, object } from 'yup';
import {
  arrayOfStringsScheme,
  excludedLanguagesScheme,
  languageScheme,
  stringScheme,
  websiteLinksScheme,
} from 'src/utils/validation-schemes';

// Pure schema factory so new persona fields only need an entry here, not a
// change to the form hook or the page component (open/closed on new fields).
export const buildConfigurationValidationSchema = (
  formFieldsObject: Record<string, any>,
  systemPromptActive: boolean,
) =>
  yup.lazy((values: any) => {
    if (systemPromptActive) {
      return object({ text: stringScheme({ required: true }) });
    }

    return object({
      pf_ai_name: stringScheme({
        required: formFieldsObject.pf_ai_name?.is_required || false,
      }).label('AI Identity'),
      pf_company_name: stringScheme({
        required: formFieldsObject.pf_company_name?.is_required || false,
      }).label('Project Name*'),
      pf_company_description: stringScheme({
        required: formFieldsObject.pf_company_description?.is_required || false,
      }).label('Project Description*'),
      pf_pages: websiteLinksScheme({
        required: formFieldsObject?.pf_pages?.is_required || false,
      }).label('Website Links'),
      pf_role: stringScheme({
        required: formFieldsObject?.pf_role?.is_required || false,
      }).label('Role'),
      pf_role_custom: stringScheme({
        required: formFieldsObject?.pf_role_custom?.is_required || values.pf_role === 'custom',
      }).label('Role - Custom'),
      pf_tone_of_voice_channel: stringScheme({
        required: formFieldsObject?.pf_tone_of_voice_channel?.is_required || false,
      }).label('Tone of Voice Channel'),
      pf_tone_of_voice_style: stringScheme({
        required: formFieldsObject?.pf_tone_of_voice_style?.is_required || false,
      }).label('Tone of Voice Style'),
      pf_tone_of_voice_style_custom: stringScheme({
        required:
          formFieldsObject?.pf_tone_of_voice_style_custom?.is_required ||
          values.pf_tone_of_voice_style === 'custom',
      }).label('Tone of Voice Style - Custom'),
      pf_default_language: languageScheme({
        required: formFieldsObject?.pf_default_language?.is_required || false,
      }).label('Default Language'),
      pf_excluded_languages: excludedLanguagesScheme({
        required: formFieldsObject?.pf_excluded_languages?.is_required || false,
      }).label('Excluded Languages'),
      pf_words_blacklist: arrayOfStringsScheme({
        required: formFieldsObject?.pf_words_blacklist?.is_required || false,
      }).label('Words blacklist'),
      pf_custom_workflows: array(
        object({
          name: stringScheme({ required: false }),
          description: stringScheme({ required: false }),
        }),
      ),
    });
  });
